<template>
  <div v-if="value" :class="$style.root">
    <div :class="$style.title">{{value}}</div>
  </div>
</template>

<script>
export default {
  props: ['value'],
};
</script>

<style module>
.root {
  font: 12px/1.7em Noto Sans CJK JP, 'Open Sans', sans-serif;
  color: #fff;
  padding: 5px 8px;
  background: linear-gradient(to bottom, rgba(0, 0, 0, 0.5), transparent);
  position: absolute;
  width: 100%;
  top: 0;
  left: 0;
  box-sizing: border-box;
  font-size: 12px;
}

.title {
  height: 20px;
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// TitleBar.vue?391858c6